export default {"src":"https://static.jusbr.com/web/docview/_next/static/media/validation.45de03cd.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};